import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { formatedNumber } from '../../Functions/convertNumber';
import { formatedDateClient } from '../../Functions/convertDate';
import { exportTDetailFacture } from '../../Functions/exportEcxelDetailFact';

import '../../Css/FactureEtablie.css';

const FacturesTable = () => {
    const [factures, setFactures] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [rowspage, setRowsPage ] = useState(12);
    const [filters, setFilters] = useState({
        organisme: "",
        id_facture: "",
        hotel: "",
        nbrfact: "",
        startDate: new Date().toISOString().split('T')[0], 
        endDate: new Date().toISOString().split('T')[0],   
        solde: "",
        description: "",
        unitPrice: "",
        quantiteConsom: "",
        totalConsom: "",
    });
    const [currentPage, setCurrentPage] = useState(0); 

    const token = localStorage.getItem('token'); 
    const apiUrl = process.env.REACT_APP_API_URL;


    const handleFilterChange = useCallback(
        (e) => {
            const { name, value } = e.target;
            setFilters((prev) => ({ ...prev, [name]: value }));
        },
        [setFilters]
    );




          const handleKeyPress = useCallback((event) => {
            if (event.key === 'Enter') {
              setFilters((prev) => ({ ...prev, date: "" })); 
              fetchData();
            }
          }, [filters]);
        
          useEffect(() => {
            window.addEventListener('keydown', handleKeyPress);
        
            return () => {
              window.removeEventListener('keydown', handleKeyPress);
            };
          }, [handleKeyPress]);
    
    




    const handleSearchClick = () => {
        fetchData();
    };


    

      useEffect(() => {
        fetchData();
      }, []);







    const paginateData = useMemo(() => {
        if (!Array.isArray(factures)) {
            return []; 
        }
                const sortedFactures = [...factures].sort((a, b) => {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
            
                const startIndex = (currentPage - 0) * rowspage;
                const endIndex = startIndex + parseInt(rowspage);
                return sortedFactures.slice(startIndex, endIndex);
    }, [factures, currentPage, rowspage]);




    let totalPages='';

    if(factures.length > 0){
        totalPages = Math.ceil(factures.length / rowspage);
    }else{
        totalPages = 0;
    }

    const isPrevDisabled = currentPage === 0 || factures.length < rowspage;
    const isNextDisabled = currentPage === totalPages || factures.length === 0;
    
    const goToPage = (page) => setCurrentPage(page);

        // Handle change Montant_achat field
        const handleRowsPageChange = (e) => {
            let value = e.target.value;
             setRowsPage(value);
        };


    const fetchData = async () => {
        setLoading(true);
        setError(null); 
        setFactures('');

        try {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.append(key, filters[key]);
                }
            });
            const facturesRes = await fetch(`${apiUrl}/api/facture/consommation?${params.toString()}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
            });

            const facturesData = await facturesRes.json();

            if(facturesData.length > 0){
                setCurrentPage(1);
            }


            setFactures(facturesData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return (
            <div className="loader">
                <div className="spinner"></div>
            </div>
        );
    }

    if (error) {
        return <div className='Facturetablie__ErrorAPI'>Error: {error}</div>;
    }

    // Action handlers
    const exportTableInExcel = () => exportTDetailFacture(factures);

    return (
        <div className="Facturetablie">
    <h2 className="Facturetablie__title">Analyse des Extras des Factures</h2>

    <div className="Facturetablie__filterSection1">
        <div className='Facturetablie__SearchDtate'>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="startDate">Start Date</label>
                <input
                   type="date"
                   id="startDate"
                   className="Facturetablie__filterInput"
                   name="startDate"
                   value={filters.startDate}
                   onChange={handleFilterChange}
                />
            </div>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="endDate">End Date</label>
                <input
                   type="date"
                   id="endDate"
                   className="Facturetablie__filterInput"
                   name="endDate"
                   value={filters.endDate}
                   onChange={handleFilterChange}
                />
            </div>
        </div>
        <div className='Facturetablie__filterSection'>
            {[
                { filter: "organisme", label: "Organisme" },
                { filter: "id_facture", label: "N° Facture" },
                { filter: "hotel", label: "Hôtel" },
                { filter: "nbrfact", label: "N° Fct Achat" },
                { filter: "solde", label: "Mnt Vente" },
                { filter: "description", label: "Type Consommation" },
            ].map(({ filter, label, index }) => (
        <div 
            className="Facturetablie__filterGroup1" 
            key={index}
        >
            <label htmlFor={label}>{label}</label>
            <input
                className="Facturetablie__filterInput"
                type='text'
                name={filter}
                id={filter}
                value={filters[filter]}
                onChange={handleFilterChange}
                placeholder='filter'
            />
        </div>
    ))}
</div>

        <button className="Facturetablie__searchButton" onClick={handleSearchClick}>Search</button>
    </div>

    <div className="Facturetablie__exportation">
        <button className="Facturetablie__exportButton" onClick={exportTableInExcel}>Exporter en Excel</button>
    </div>



    {/* Pagination */}
    <div className='Facturetablie__paginationarea'>
        <div className="Facturetablie__pagination">
           <button disabled={isPrevDisabled} onClick={() => goToPage(currentPage - 1)}>&lt; Prev</button>
           <span>Page {currentPage} of {totalPages}</span>
           <button disabled={isNextDisabled} onClick={() => goToPage(currentPage + 1)}>Next &gt;</button>

           <input
            type="text"
            className="Facturetablie__rowspage"
            value={rowspage}
            onChange={handleRowsPageChange}
        />
        </div>
    </div>


                <table className="Facturetablie__table">
                    <thead>
                        <tr className="Facturetablie__headerRow">
                            {[
                                { name: "date", label: "Date" },
                                { name: "organisme", label: "Organisme" },
                                { name: "hotel", label: "Hôtel" },
                                { name: "nbrfact", label: "N° Fct Hôtel" },
                                { name: "id_facture", label: "Facture" },
                                { name: "solde", label: "Montant" },
                                { name: "description", label: "Description" },
                                { name: "unitPrice", label: "unitPrice" },
                                { name: "quantiteConsom", label: "quantiteConsom" },
                                { name: "totalConsom", label: "totalConsom" },
                            ].map(({ name, label }) => (
                                <th key={name}>{label}</th>
                            ))}
                        </tr>
                    </thead>
    
                    <tbody>
                        {paginateData.length > 0 ? (
                            paginateData.map((item) =>
                                    item.consommations.map((consommation, index) => (
                                        <tr key={`${item.id}-${index}`}>
                                            {index === 0 && (
                                                <>
                                                    <td rowSpan={item.consommations.length}>{formatedDateClient(item.currentDate)}</td>
                                                    <td rowSpan={item.consommations.length}>{item.selectedorganisme}</td>
                                                    <td rowSpan={item.consommations.length}>{item.selectedHotel}</td>
                                                    <td rowSpan={item.consommations.length}>{item.nbrfact}</td>
                                                    <td rowSpan={item.consommations.length}>{item.id_facture}</td>
                                                    <td rowSpan={item.consommations.length}>{formatedNumber(item.solde)}</td>
                                                </>
                                            )}
                                            <td>{consommation.description}</td>
                                            <td>{formatedNumber(consommation.unitPrice)}</td>
                                            <td>{consommation.quantiteConsom}</td>
                                            <td>{formatedNumber(consommation.totalConsom)}</td>
                                        </tr>
                                    ))
                            )
                        ) : (
                            <tr><td colSpan="10" className='not-found'>No results found.</td></tr>
                        )}
                    </tbody>
                </table>
</div>

    );
};

export default FacturesTable;




